import React, { FC, useCallback } from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { useTranslation } from '@wix/yoshi-flow-editor';
import { Text, TextButton } from 'wix-ui-tpa/cssVars';

import { DataHook } from '../../../../../constants/DataHook';
import settingsParams from '../../../settingsParams';
import { SectionHeader } from '../../common/SectionHeader';
import { Divider } from '../../common/Divider';
import { useMember } from '../../../../../contexts/widget';
import { classes } from './LoginInfo.st.css';
import { useModal } from '../../../../../contexts/modals/hooks';
import { ChangeLoginEmailModal, ChangeLoginPasswordModal } from '../../modals';
import { useBi } from '../../../../../hooks';
import { ConditionalWarningOrCta } from './ConditionalWarningOrCta';

export const LoginInfo: FC = () => {
  const settings = useSettings();
  const { t } = useTranslation();
  const { loginEmail } = useMember();
  const { showModal } = useModal();
  const biLogger = useBi();

  const showChangeLoginEmailModal = useCallback(() => {
    biLogger.memberClickedOnChangeEmail();
    showModal(ChangeLoginEmailModal);
  }, [showModal, biLogger]);
  const showChangeLoginPasswordModal = useCallback(() => {
    biLogger.memberClickedOnChangePassword();
    showModal(ChangeLoginPasswordModal);
  }, [showModal, biLogger]);

  return (
    <div className={classes.root} data-hook={DataHook.LoginInfoSection}>
      <SectionHeader
        title={settings.get(settingsParams.loginInfoSectionTitle)}
        subtitle={settings.get(settingsParams.loginInfoSectionSubtitle)}
      />
      <div className={classes.content}>
        <div>
          <Text className={classes.title} tagName="div">
            {t('app.widget.sections.login-info.email.title')}
          </Text>
          <Text className={classes.title} tagName="div">
            {loginEmail}
          </Text>
          <ConditionalWarningOrCta fieldName="email">
            <TextButton
              data-hook={DataHook.LoginInfoSectionChangeEmail}
              onClick={showChangeLoginEmailModal}
              className={classes.button}
            >
              {t('app.widget.sections.login-info.email.action')}
            </TextButton>
          </ConditionalWarningOrCta>
        </div>

        <div>
          <Text tagName="div">
            {t('app.widget.sections.login-info.password.title')}
          </Text>
          <Text tagName="div">● ● ● ● ● ●</Text>
          <ConditionalWarningOrCta fieldName="password">
            <TextButton
              data-hook={DataHook.LoginInfoSectionChangePassword}
              onClick={showChangeLoginPasswordModal}
              className={classes.button}
            >
              {t('app.widget.sections.login-info.password.action')}
            </TextButton>
          </ConditionalWarningOrCta>
        </div>
      </div>

      <Divider />
    </div>
  );
};
